import React, { useEffect, useRef } from "react";
import { useNavigate, useRouteError } from "react-router-dom";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import {
  attemptChunkReload,
  isChunkLoadError,
} from "../../../utils/functions/lazyWithRetry";

export const OrderConfirmErrorRedirect: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const error = useRouteError();
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;
    // A chunk-load failure (stale deploy) is not an order problem: don't
    // blame the order with a "something went wrong" toast — reload once
    // (guarded) to pick up the fresh assets instead. If the guard for this
    // pathname is already spent, fall through to the original redirect.
    if (isChunkLoadError(error) && attemptChunkReload()) return;
    toast.error(t("orderConfirmation.somethingWentWrong"));
    navigate("/order/place");
  }, [navigate, t, error]);

  return null;
};
